import { Env } from "./types";
var production = {
    environment: Env.PRODUCTION,
    userApiBaseUrl: 'https://backend.logicdialog.ai/api/user/',
    socketServerUrl: 'https://external-socket-server.logicdialog.ai/',
    conversationApiBaseUrl: 'https://backend.logicdialog.ai/api/conversations/',
    socketServerApiUri: 'https://socket-server-input.logicdialog.ai/api/user'
};
export default production;
